import { Component, Inject } from '@angular/core';
import { TranslatorService } from '../../services/translator_service';
import { ResponsiveService } from '../../services/responsive.service';
import { ApiService } from '../../web-services/api/api.service';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';
import { RTLDivDirectiveDirective } from '../../directives/rtldiv-directive.directive';

@Component({
  selector: 'app-custom-snackbar',
  standalone: true,
  imports: [TranslateModule, RTLDivDirectiveDirective],
  templateUrl: './custom-snackbar.component.html',
  styleUrl: './custom-snackbar.component.scss'
})
export class CustomSnackbarComponent {
  isMobile: boolean;
	currentLang;
	translationsObj;

  constructor(private translator: TranslatorService,private responsiveService: ResponsiveService,private apiService:ApiService,
    public snackBarRef: MatSnackBarRef<CustomSnackbarComponent>, @Inject(MAT_SNACK_BAR_DATA) public data: any) {  
      this.translator.currentLangEmitter$
      .subscribe(async value=>{						
        this.translationsObj = await this.translator.getTranslation(value).toPromise()			 
        this.currentLang = value;
      }); 
  }

  ngOnInit() {
    this.onResize();
    this.responsiveService.checkWidth();
  }

  onResize() {
		this.responsiveService.getMobileStatus().subscribe(isMobile => {
		  this.isMobile = isMobile;
		});
	}

  closeSnackbar() {
    this.snackBarRef.dismiss();
  }

  undo(){
    this.snackBarRef.dismissWithAction();
  }
}
